<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('ajoutEditContrat.pj.title')}}
      </p>
    </header>
    <div class="card-content">
      <piecesJointes :checkPermissions="true"/>
    </div>
  </div>
</template>

<script>
import piecesJointes from '@/components/general/piecesJointes';

export default {
  name: 'pieceJointe',
  components: {
    piecesJointes,
  },
};
</script>

<style scoped>

</style>
